// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2JTK0","messages":"Chat_messages__3JeW6","dateDivider":"Chat_dateDivider__2iwiQ"};